import { useGroup } from '../contexts/GroupContext.jsx';

const WRITE_ROLES = new Set(['owner', 'editor']);
const OWNER_ROLES = new Set(['owner']);

export const useCanEdit = () => {
  const { userRole } = useGroup();
  return WRITE_ROLES.has(userRole);
};

export const useIsOwner = () => {
  const { userRole } = useGroup();
  return OWNER_ROLES.has(userRole);
};

export const EditorOnly = ({ children, fallback = null }) => {
  return useCanEdit() ? <>{children}</> : fallback;
};

export const OwnerOnly = ({ children, fallback = null }) => {
  return useIsOwner() ? <>{children}</> : fallback;
};
